import { ThemeSelectors, TypeSmart } from "@at/design-system-foundation";

import styled, { css } from "styled-components";

import { isUserInRedButtonTest } from "../../../utils/ab-test/ab-test.util";

const bannerItemStyling = css`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  display: flex;
  text-decoration: underline;
`;

export const Banner = styled.div`
  width: 100%;
  height: 50px;
  position: relative;
  overflow-x: hidden;
  @media print {
    margin: ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme)} 0;
  }
`;

export const BannerBackground = styled.div`
  width: 100%;
  height: 100%;
  left: 0;
  position: absolute;
  background: ${isUserInRedButtonTest
    ? "#F7F6F5"
    : ({ theme }) => ThemeSelectors.getColorDecorBgSurfaceSoft(theme)};
`;

export const BannerItemButton = styled.button`
  ${bannerItemStyling}
`;

export const BannerItemLink = styled.a`
  ${bannerItemStyling}
`;

export const BannerItemText = styled(TypeSmart).attrs({ as: "span" })`
  margin-left: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
  color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
  font-variation-settings: "wght" 500;
`;
